import { GroupIds } from "@/shared/group-configs/group-ids";

export { GroupIds } from "@/shared/group-configs/group-ids";

export enum GroupNames {
  CONVENIENT_MD = "ConvenientMD",
  ENT_PARTNERS = "Chicago ENT",
  ENT_PARTNERS_SCI = "Specialty Care ENT",
  NIRA = "Central Texas Neurology Consultants",
  NIMBUS = "Nimbus Health",
  SPORT_ORTHO = "Sport Ortho Urgent Care",
  UPPERLINE_GA = "Upperline Georgia",
  VALERIE = "Valerie Health",
}

// Preserve the voice API and eval validation scope independently of the full tenant registry.
export const VOICE_GROUP_IDS = [
  GroupIds.CONVENIENT_MD_LIVE,
  GroupIds.CONVENIENT_MD_LIVE_SANDBOX,
  GroupIds.ENT_PARTNERS_LIVE,
  GroupIds.ENT_PARTNERS_LIVE_SANDBOX,
  GroupIds.ENT_PARTNERS_SCI_LIVE,
  GroupIds.ENT_PARTNERS_SCI_LIVE_SANDBOX,
  GroupIds.USHV_HEARTPLACE_LIVE,
  GroupIds.USHV_HEARTPLACE_LIVE_SANDBOX,
  GroupIds.NIRA_LIVE,
  GroupIds.NIRA_LIVE_SANDBOX,
  GroupIds.UPPERLINE_GEORGIA_LIVE,
  GroupIds.UPPERLINE_GEORGIA_LIVE_SANDBOX,
  GroupIds.VALERIE_HEALTH_DEV,
  GroupIds.VALERIE_HEALTH_GENERIC_DEMO,
  GroupIds.VALERIE_HEALTH_LIVE,
  GroupIds.VALERIE_HEALTH_LIVE_SANDBOX,
  GroupIds.BALANCE_HEALTH_LIVE,
  GroupIds.BALANCE_HEALTH_LIVE_SANDBOX,
  GroupIds.USHV_PIMA_LIVE,
  GroupIds.USHV_PIMA_LIVE_SANDBOX,
  GroupIds.USHV_MKC_LIVE,
  GroupIds.USHV_MKC_LIVE_SANDBOX,
  GroupIds.NIMBUS_LIVE,
  GroupIds.NIMBUS_LIVE_SANDBOX,
  GroupIds.SPORTORTHO_LIVE,
  GroupIds.SPORTORTHO_LIVE_SANDBOX,
  GroupIds.TPR_BILTMORE_LIVE,
  GroupIds.TPR_BILTMORE_LIVE_SANDBOX,
  GroupIds.UNITED_VEIN_AND_VASCULAR_CENTERS_LIVE,
  GroupIds.UNITED_VEIN_AND_VASCULAR_CENTERS_LIVE_SANDBOX,
  GroupIds.AXIA_LIVE,
  GroupIds.AXIA_LIVE_SANDBOX,
  GroupIds.PMG_LIVE_SANDBOX,
] as const satisfies readonly GroupIds[];

/**
 * Default clinic-local timezone for Voice groups. Site-aware lines may override this with their
 * resolved site timezone (for example, Nimbus Sun City West).
 */
export const GROUP_DEFAULT_TIME_ZONES: Readonly<Partial<Record<GroupIds, string>>> = Object.freeze({
  [GroupIds.CONVENIENT_MD_LIVE]: "America/New_York",
  [GroupIds.CONVENIENT_MD_LIVE_SANDBOX]: "America/New_York",
  [GroupIds.ENT_PARTNERS_LIVE]: "America/Chicago",
  [GroupIds.ENT_PARTNERS_LIVE_SANDBOX]: "America/Chicago",
  [GroupIds.ENT_PARTNERS_SCI_LIVE]: "America/Chicago",
  [GroupIds.ENT_PARTNERS_SCI_LIVE_SANDBOX]: "America/Chicago",
  [GroupIds.PMG_LIVE_SANDBOX]: "America/Chicago",
  [GroupIds.USHV_HEARTPLACE_LIVE]: "America/Chicago",
  [GroupIds.USHV_HEARTPLACE_LIVE_SANDBOX]: "America/Chicago",
  [GroupIds.NIRA_LIVE]: "America/Chicago",
  [GroupIds.NIRA_LIVE_SANDBOX]: "America/Chicago",
  [GroupIds.UPPERLINE_GEORGIA_LIVE]: "America/New_York",
  [GroupIds.UPPERLINE_GEORGIA_LIVE_SANDBOX]: "America/New_York",
  [GroupIds.NIMBUS_LIVE]: "America/New_York",
  [GroupIds.NIMBUS_LIVE_SANDBOX]: "America/New_York",
  [GroupIds.SPORTORTHO_LIVE]: "America/Chicago",
  [GroupIds.SPORTORTHO_LIVE_SANDBOX]: "America/Chicago",
  [GroupIds.TPR_BILTMORE_LIVE]: "America/Phoenix",
  [GroupIds.TPR_BILTMORE_LIVE_SANDBOX]: "America/Phoenix",
  [GroupIds.VALERIE_HEALTH_DEV]: "America/Chicago",
  [GroupIds.VALERIE_HEALTH_GENERIC_DEMO]: "America/Los_Angeles",
  [GroupIds.VALERIE_HEALTH_LIVE_SANDBOX]: "America/Chicago",
});

export const DEMO_AGENT_V1 = "17737404006";
export const DEMO_AGENT_V2 = "17737404002";
export const STAGING_NUMBER = "12402124097";
export const VOICE_STAGING_TWILIO_NUMBER = "+16303946071";
export const USHV_MKC_SANDBOX_TWILIO_NUMBER = "+17752629454";
export const HEARTPLACE_SANDBOX_TWILIO_NUMBER = "+13367337125";
export const CONVENIENT_MD_BANGOR_LINE = "+12078062948";
export const CONVENIENT_MD_BANGOR_AUTO_ATTENDANT_LINE = "+12079554415"; // internal extension 889209
export const CONVENIENT_MD_BANGOR_FRONT_DESK_LINE = "+12075440960";
export const CONVENIENT_MD_HADLEY_LINE = "+14133405346";
export const CONVENIENT_MD_HADLEY_AUTO_ATTENDANT_LINE = "+14132426996"; // internal extension 889207
export const CONVENIENT_MD_HADLEY_FRONT_DESK_LINE = "+14133734502";
export const CONVENIENT_MD_KEENE_LINE = "+18027277521";
export const CONVENIENT_MD_KEENE_AUTO_ATTENDANT_LINE = "+16039120103"; // internal extension 889208
export const CONVENIENT_MD_KEENE_FRONT_DESK_LINE = "+16032565163";
export const CONVENIENT_MD_QUINCY_LINE = "+18578582189";
export const CONVENIENT_MD_QUINCY_AUTO_ATTENDANT_LINE = "+13394638383"; // internal extension 889206
export const CONVENIENT_MD_QUINCY_FRONT_DESK_LINE = "+19787986857";
export const CONVENIENT_MD_TEST_LINE = "+15512506773";
export const CONVENIENT_MD_AUTO_RECEPTIONIST_LINE = "+16034580395";
export const CONVENIENT_MD_AUTO_RECEPTIONIST_SEND_DIGITS = "w125";
export const CONVENIENT_MD_TRANSFER_LINE = "+16039120106";
export const CONVENIENT_MD_FRONT_DESK_LINE = CONVENIENT_MD_TRANSFER_LINE;
export const CONVENIENT_MD_FRONT_DESK_SEND_DIGITS = "w124";
export const CONVENIENT_MD_RCM_BILLING_LINE = "+16034106700";
export const CONVENIENT_MD_EMPLOYER_SERVICES_LINE = "+16036145566";
export const CONVENIENT_MD_VUC_LINE = "+18332630131";
export const CONVENIENT_MD_APC_ENROLLMENT_LINE = "+16038106700";
// The pilot clinic lines serve real callers on the live group; the test line stays on the sandbox group.
export const CONVENIENT_MD_PILOT_SITE_LINES = [
  CONVENIENT_MD_BANGOR_LINE,
  CONVENIENT_MD_HADLEY_LINE,
  CONVENIENT_MD_KEENE_LINE,
  CONVENIENT_MD_QUINCY_LINE,
] as const;
export const CONVENIENT_MD_LINES = [CONVENIENT_MD_TEST_LINE, ...CONVENIENT_MD_PILOT_SITE_LINES] as const;
// Calls that do not enter LiveKit return to each site's auto attendant. The original test line
// retains its existing fallback because it is not tied to one pilot site.
export const CONVENIENT_MD_AUTO_ATTENDANT_LINE_BY_INBOUND_LINE = {
  [CONVENIENT_MD_TEST_LINE]: CONVENIENT_MD_TRANSFER_LINE,
  [CONVENIENT_MD_BANGOR_LINE]: CONVENIENT_MD_BANGOR_AUTO_ATTENDANT_LINE,
  [CONVENIENT_MD_HADLEY_LINE]: CONVENIENT_MD_HADLEY_AUTO_ATTENDANT_LINE,
  [CONVENIENT_MD_KEENE_LINE]: CONVENIENT_MD_KEENE_AUTO_ATTENDANT_LINE,
  [CONVENIENT_MD_QUINCY_LINE]: CONVENIENT_MD_QUINCY_AUTO_ATTENDANT_LINE,
} as const satisfies Readonly<Record<(typeof CONVENIENT_MD_LINES)[number], string>>;

// Once the agent owns a call, human handoffs bypass the forwarding auto attendant and dial the
// site's direct front desk so the transfer cannot loop back through Valerie.
export const CONVENIENT_MD_FRONT_DESK_LINE_BY_INBOUND_LINE = {
  [CONVENIENT_MD_TEST_LINE]: CONVENIENT_MD_TRANSFER_LINE,
  [CONVENIENT_MD_BANGOR_LINE]: CONVENIENT_MD_BANGOR_FRONT_DESK_LINE,
  [CONVENIENT_MD_HADLEY_LINE]: CONVENIENT_MD_HADLEY_FRONT_DESK_LINE,
  [CONVENIENT_MD_KEENE_LINE]: CONVENIENT_MD_KEENE_FRONT_DESK_LINE,
  [CONVENIENT_MD_QUINCY_LINE]: CONVENIENT_MD_QUINCY_FRONT_DESK_LINE,
} as const satisfies Readonly<Record<(typeof CONVENIENT_MD_LINES)[number], string>>;
// Sport Ortho's only inbound Voice DID. Routes to SPORTORTHO_LIVE, so calls read and write the
// real Athena tenant. It stays in TEST_ENV_NUMBERS to keep its calls out of #voice-alerts, but its
// transfers are placed for real to the Brentwood extensions (see LIVE_TRANSFER_DEMO_LINES).
export const SPORT_ORTHO_DEMO_LINE = "+16292992579"; // the new Twilio number
// Dedicated SMS-only sandbox DID. Voice routing for this number remains unchanged in Twilio.
export const SPORT_ORTHO_SMS_SANDBOX_LINE = "+16292785420";
// Reserved fictional number for API/eval site binding only; not a Twilio DID or an inbound route.
export const SPORT_ORTHO_FIXTURE_LINE = "+16155550199";
// PMG central sandbox number; all clinic locations share this inbound line.
export const PMG_SANDBOX_TWILIO_NUMBER = "+19386668599";
export const SPORT_ORTHO_TRANSFER_LINE = "+16153709992"; // Brentwood branch general line
export const SPORT_ORTHO_TRANSFER_SEND_DIGITS = "w*2011"; // Brentwood branch ext for existing patient scheduling
// Remaining Brentwood branch escalation-table extensions (all dialed via SPORT_ORTHO_TRANSFER_LINE).
export const SPORT_ORTHO_APPOINTMENTS_SEND_DIGITS = "w*2220"; // new-patient appointments
export const SPORT_ORTHO_REFILL_PRESCRIPTION_SEND_DIGITS = "w*2012"; // prescription refill
export const SPORT_ORTHO_PAY_BILL_SEND_DIGITS = "w*3000"; // pay a bill
export const SPORT_ORTHO_BILLING_SEND_DIGITS = "w*3001"; // billing question
export const SPORT_ORTHO_MEDICAL_RECORDS_SEND_DIGITS = "w*4000"; // medical records request
export const SPORT_ORTHO_MRI_COORDINATOR_SEND_DIGITS = "w*4002"; // MRI appointment or question
export const SPORT_ORTHO_PERSONAL_INJURY_COORDINATOR_SEND_DIGITS = "w*4003"; // personal injury
export const SPORT_ORTHO_SURGICAL_COORDINATOR_SEND_DIGITS = "w*4001"; // surgery appointment/question, surgery on chart
export const SPORT_ORTHO_WORKERS_COMP_COORDINATOR_SEND_DIGITS = "w*4004"; // workers' comp question

// Axia extension-dialing trial: a prospect with no group of its own yet, so the demo line runs the
// sandbox agent (same arrangement as CONVENIENT_MD_TEST_LINE) purely to prove Twilio can reach an
// extension behind their main line.
export const AXIA_DEMO_LINE = "+19739658135";
export const AXIA_TRANSFER_LINE = "+19737361100"; // main line the extension is dialed behind
// Surgery booking queue. `w` is a half-second Twilio pause before the digits go out, which a
// manual test showed is enough -- their line accepted the extension immediately on answer. Their
// system took the extension with and without the leading `*`, so it is kept for safety, matching
// how Sport Ortho's extensions are dialed.
export const AXIA_TRANSFER_SEND_DIGITS = "w*180553";
// Axia's OGI North Val number, the first of its four lines on the agent. It reaches AXIA_LIVE, so
// lookups read Axia's real eCW, but it stays in TEST_ENV_NUMBERS until the pilot: transfers are
// announced rather than placed, and calls stay out of #voice-alerts. Axia forwards no clinic
// traffic to it until Valerie confirms the line answers.
export const AXIA_OGI_NORTH_LINE = "+13177517954";
// Axia's Val number for CTWH Blue Bell, routed like AXIA_OGI_NORTH_LINE: it reaches AXIA_LIVE but
// stays in TEST_ENV_NUMBERS, and Axia forwards no clinic traffic to it until Valerie confirms it answers.
export const AXIA_BLUE_BELL_LINE = "+12673802467";
// Axia's Val number for CTWH Lansdale, routed like AXIA_OGI_NORTH_LINE: it reaches AXIA_LIVE but
// stays in TEST_ENV_NUMBERS, and Axia forwards no clinic traffic to it until Valerie confirms it answers.
export const AXIA_LANSDALE_LINE = "+12676493074";
// Axia's Val number for CTWH Pottstown, routed like AXIA_OGI_NORTH_LINE: it reaches AXIA_LIVE but
// stays in TEST_ENV_NUMBERS, and Axia forwards no clinic traffic to it until Valerie confirms it answers.
export const AXIA_POTTSTOWN_LINE = "+14849463915";
// Reserved fictional numbers, one per Axia line, that bind API and eval calls to that line's site and
// routing in the Axia sandbox. None is a Twilio DID or an inbound route.
export const AXIA_OGI_NORTH_FIXTURE_LINE = "+13175550191";
export const AXIA_BLUE_BELL_FIXTURE_LINE = "+12675550192";
export const AXIA_LANSDALE_FIXTURE_LINE = "+12675550193";
export const AXIA_POTTSTOWN_FIXTURE_LINE = "+14845550194";

// Mock test lines (VAL-1882 / VAL-1883): route to the *_LIVE_SANDBOX groups, which run the real
// entp / entp-sci / upperline-ga workflows against the Supabase mock EHR/scheduler (no real EHR side effects).
// Alert suppression for these is by GROUP (see MOCK_TEST_GROUP_IDS), not by number.
export const CENT_MOCK_LINE = "+19498684288";
export const ENTP_MOCK_LINE = "+18776744317";
export const ENTP_SCI_MOCK_LINE = "+12608234006";
export const NIMBUS_ROCK_HILL_MOCK_LINE = "+17348884243";
export const NIMBUS_SCW_MOCK_LINE = "+14722124190";
export const NIMBUS_MACON_MOCK_LINE = "+16626861525";
// Dedicated inbound Voice test line; sandbox SMS/outreach uses a separate number.
export const TPR_BILTMORE_VOICE_MOCK_LINE = "+16015339243";
export const TPR_BILTMORE_TELNYX_TEST_LINE = "+16025870856";
export const UPPERLINE_GA_MOCK_LINE = "+16507064884";

export const TEST_ENV_NUMBERS = [
  DEMO_AGENT_V1,
  DEMO_AGENT_V2,
  STAGING_NUMBER,
  VOICE_STAGING_TWILIO_NUMBER,
  ...CONVENIENT_MD_LINES,
  // Stays here even though the line now reaches SPORTORTHO_LIVE, because membership keeps the
  // calls out of #voice-alerts. Two test-line defaults don't apply to it: its transfers are placed
  // for real (LIVE_TRANSFER_DEMO_LINES), and its calls are saved (CALL_HISTORY_TEST_LINES).
  SPORT_ORTHO_DEMO_LINE,
  AXIA_DEMO_LINE,
  AXIA_OGI_NORTH_LINE,
  AXIA_BLUE_BELL_LINE,
  AXIA_LANSDALE_LINE,
  AXIA_POTTSTOWN_LINE,
  // Telnyx supplies a SIP call ID instead of a Twilio SID; transfers remain simulated.
  TPR_BILTMORE_TELNYX_TEST_LINE,
  PMG_SANDBOX_TWILIO_NUMBER,
];

/**
 * Demo lines that must place a real transfer even though they are test-environment numbers.
 *
 * A test-environment call normally announces where it *would* have transferred instead of dialing,
 * which is the right default but makes an extension-dialing trial prove nothing. Listing a line
 * here restores real dialing for it, and only when the call carries a real Twilio call SID, so
 * local and console sessions keep simulating.
 *
 * Sport Ortho's test line is listed so its test calls reach the real Brentwood extensions, which
 * means Sport Ortho staff answer them.
 */
export const LIVE_TRANSFER_DEMO_LINES: string[] = [AXIA_DEMO_LINE, SPORT_ORTHO_DEMO_LINE];

/**
 * Test-environment lines whose calls are still saved like a live line's: transcript, recording,
 * tool audits, and post-call evaluation.
 *
 * Each call otherwise stays a test call. Transfers are announced rather than placed unless the line
 * is also in LIVE_TRANSFER_DEMO_LINES, and the saved transcript is marked as a test call, so it
 * raises no #voice-alerts post, engagement, CSAT, or intake SMS. Local sessions save nothing.
 */
export const CALL_HISTORY_TEST_LINES: string[] = [SPORT_ORTHO_DEMO_LINE];

// Groups used purely for testing against the Supabase mock EHR/scheduler (VAL-1820/1882/1883). Calls
// to these are excluded from transcript ingestion / #voice-alerts regardless of the dialed number —
// suppression by org, not by line, so it holds for any inbound path (mock number, staging, etc.).
export const MOCK_TEST_GROUP_IDS: GroupIds[] = [
  GroupIds.SPORTORTHO_LIVE_SANDBOX,
  GroupIds.VALERIE_HEALTH_GENERIC_DEMO,
  GroupIds.VALERIE_HEALTH_LIVE_SANDBOX,
  GroupIds.ENT_PARTNERS_LIVE_SANDBOX,
  GroupIds.ENT_PARTNERS_SCI_LIVE_SANDBOX,
  GroupIds.NIMBUS_LIVE_SANDBOX,
  GroupIds.TPR_BILTMORE_LIVE_SANDBOX,
  GroupIds.UPPERLINE_GEORGIA_LIVE_SANDBOX,
  GroupIds.AXIA_LIVE_SANDBOX,
  GroupIds.PMG_LIVE_SANDBOX,
];

export const SAMPLE_ALLOW_LIST = [
  "+19255889354",
  "+18474173869",
  "+15122645802",
  "+18479702471",
  "+19145526753",
  "+13365546880",
  "+16696009800",
  "+12174171293",
];

export const CTNC_NEW_PATIENT_LINE = "+15128773634";
export const CTNC_NEW_PATIENT_TRANSFER_LINE = "+15127661164";
export const CTNC_EXISTING_PATIENT_LINE = "+15126018189";
export const CTNC_EXISTING_PATIENT_TRANSFER_LINE = "+15127667966";

export const NIMBUS_SCW_LINE = "+16233215578";
export const NIMBUS_ROCK_HILL_LINE = "+18032675105";
export const NIMBUS_MACON_LINE = "+14783098444";

export const NIMBUS_ROCK_HILL_TRANSFER_LINE_FRONT_DESK = "+12083158415";
export const NIMBUS_ROCK_HILL_TRANSFER_LINE_MA = "+12083159161";
export const NIMBUS_ROCK_HILL_TRANSFER_LINE_PROGRAMS = "+12028071076";

export const TPR_BILTMORE_VOICE_LINE = "+16013274383";
// TPR-owned after-hours answering line for calls received outside the Camelback office window.
export const TPR_BILTMORE_AFTER_HOURS_LINE = "+16027873330";
// TPR-owned DID that enters the legacy 7920 dial plan. Calls outside the initial Voice sample
// forward here so the clinic keeps ownership of the non-Voice call path.
export const TPR_BILTMORE_LEGACY_IVR_LINE = "+14782019742";
// TPR-owned DID that routes directly to the appointment/new-patient escalation queue.
export const TPR_BILTMORE_APPOINTMENT_ESCALATION_LINE = "+14782008705";
// TPR-owned specialty queues for anticoagulation, implanted-device, and hospital-transfer calls.
export const TPR_BILTMORE_COUMADIN_TRANSFER_LINE = "+16028130629";
export const TPR_BILTMORE_PACEMAKER_TRANSFER_LINE = "+16023256685";
export const TPR_BILTMORE_STEMI_TRANSFER_CENTER_LINE = "+16022444099";
// TPR-owned results line for confirmed lab and imaging facility callers.
export const TPR_BILTMORE_LAB_IMAGING_RESULTS_TRANSFER_LINE = "+16029032301";
// TPR-owned main line used to reach PBX extensions through post-answer DTMF.
export const TPR_BILTMORE_EXTENSION_TRANSFER_LINE = "+16023256686";

export const UPPERLINE_GA_LINE = "+17069171729";
export const UPPERLINE_GA_TRANSFER_LINE = "+17069552843";

export const ENTP_LINE = "+17737419917";
export const ENTP_SMS_TRANSFER_LINE = "+17732965500";
export const ENTP_TRANSFER_LINE_MEDIUM_PRIORITY = "+17735963593";
export const ENTP_TRANSFER_LINE_HIGH_PRIORITY = "+17735963596";
export const ENTP_TRANSFER_LINE_STANDARD_PRIORITY = "+17735963597";
export const ENTP_TRANSFER_LINE_NOTIFY_MD = "+18002080203";
export const ENTP_TRANSFER_LINE_BILLING = "+16128878446";

// VAL-2676 CENT IVR destinations. These remain separate from the legacy ENTP
// constants so the rollout can be enabled without rewriting the current map.
export const CENT_IVR_TRANSFER_LINE_NEW_PATIENT = "+17732891835";
export const CENT_IVR_TRANSFER_LINE_ESTABLISHED_SCHEDULING = "+17732891836";
export const CENT_IVR_TRANSFER_LINE_STANDARD = "+17732891837";
export const CENT_IVR_TRANSFER_LINE_BILLING = "+17732891839";
export const CENT_IVR_TRANSFER_LINE_SPANISH = "+17732891865";
export const CENT_PRIOR_AUTHORIZATION_TRANSFER_LINE_SURGICAL = "+17732891861";
export const CENT_PRIOR_AUTHORIZATION_TRANSFER_LINE_IN_OFFICE_PROCEDURE = "+17732891828";
export const CENT_PRIOR_AUTHORIZATION_TRANSFER_LINE_MEDICATION = "+13127246560";
export const CENT_PRIOR_AUTHORIZATION_TRANSFER_LINE_SLEEP_IN_LAB = "+18722985719";
export const CENT_PRIOR_AUTHORIZATION_TRANSFER_LINE_SLEEP_DEVICE = "+17735963578";

export const ENTP_SCI_LINE = "+17086225761";
export const ENTP_SCI_TRANSFER_LINE = "+16513775275";

// Inbound-line registry. Workflow configs reference these by name (e.g.
// "CTNC_NEW_PATIENT_LINE") instead of hardcoding phone numbers; the loader
// resolves the name to the underlying number at parse time.
export const INBOUND_LINES = {
  PMG_SANDBOX_TWILIO_NUMBER,
  CTNC_NEW_PATIENT_LINE,
  CTNC_EXISTING_PATIENT_LINE,
  UPPERLINE_GA_LINE,
  ENTP_LINE,
  ENTP_SCI_LINE,
  NIMBUS_SCW_LINE,
  NIMBUS_ROCK_HILL_LINE,
  NIMBUS_MACON_LINE,
  TPR_BILTMORE_VOICE_LINE,
  TPR_BILTMORE_VOICE_MOCK_LINE,
  TPR_BILTMORE_TELNYX_TEST_LINE,
  STAGING_NUMBER,
  VOICE_STAGING_TWILIO_NUMBER,
  CONVENIENT_MD_TEST_LINE,
  CONVENIENT_MD_BANGOR_LINE,
  CONVENIENT_MD_HADLEY_LINE,
  CONVENIENT_MD_KEENE_LINE,
  CONVENIENT_MD_QUINCY_LINE,
  DEMO_AGENT_V1,
  DEMO_AGENT_V2,
  SPORT_ORTHO_DEMO_LINE,
  AXIA_DEMO_LINE,
} as const;

export type InboundLineName = keyof typeof INBOUND_LINES;

export const INBOUND_NUMBER_TO_GROUP_ID: Record<string, GroupIds> = {
  [CTNC_NEW_PATIENT_LINE]: GroupIds.NIRA_LIVE,
  [CTNC_EXISTING_PATIENT_LINE]: GroupIds.NIRA_LIVE,
  [STAGING_NUMBER]: GroupIds.VALERIE_HEALTH_LIVE_SANDBOX,
  [VOICE_STAGING_TWILIO_NUMBER]: GroupIds.VALERIE_HEALTH_LIVE_SANDBOX,
  [CONVENIENT_MD_TEST_LINE]: GroupIds.CONVENIENT_MD_LIVE_SANDBOX,
  ...Object.fromEntries(CONVENIENT_MD_PILOT_SITE_LINES.map((line) => [line, GroupIds.CONVENIENT_MD_LIVE])),
  [DEMO_AGENT_V1]: GroupIds.VALERIE_HEALTH_DEV,
  [DEMO_AGENT_V2]: GroupIds.VALERIE_HEALTH_DEV,
  // Repointed from SPORTORTHO_LIVE_SANDBOX so appointment workflows run against Sport Ortho's real
  // Athena tenant and are verifiable in their EHR. The live group also resolves the real SPORTORTHO
  // transfer mapping, so transfers (placed for real via LIVE_TRANSFER_DEMO_LINES) reach the actual
  // Brentwood extensions instead of the sandbox's dummy number. The sandbox group keeps its cohort
  // for seeding, but no inbound line reaches it now.
  [SPORT_ORTHO_DEMO_LINE]: GroupIds.SPORTORTHO_LIVE,
  // Binds the reserved fixture line to the sandbox so the eval harness can target it
  // (SUPPORTED_EVAL_GROUP_TARGETS needs an inbound line). The demo line above stays pointed at the
  // live group, so manual test calls are unaffected.
  [SPORT_ORTHO_FIXTURE_LINE]: GroupIds.SPORTORTHO_LIVE_SANDBOX,
  // Axia has no group of its own yet; the trial runs the sandbox agent, as ConvenientMD's does.
  [AXIA_DEMO_LINE]: GroupIds.VALERIE_HEALTH_LIVE_SANDBOX,
  [AXIA_OGI_NORTH_LINE]: GroupIds.AXIA_LIVE,
  [AXIA_BLUE_BELL_LINE]: GroupIds.AXIA_LIVE,
  [AXIA_LANSDALE_LINE]: GroupIds.AXIA_LIVE,
  [AXIA_POTTSTOWN_LINE]: GroupIds.AXIA_LIVE,
  // Bind the reserved fixture lines to the sandbox so the eval harness can target each Axia line
  // (SUPPORTED_EVAL_GROUP_TARGETS needs an inbound line).
  [AXIA_OGI_NORTH_FIXTURE_LINE]: GroupIds.AXIA_LIVE_SANDBOX,
  [AXIA_BLUE_BELL_FIXTURE_LINE]: GroupIds.AXIA_LIVE_SANDBOX,
  [AXIA_LANSDALE_FIXTURE_LINE]: GroupIds.AXIA_LIVE_SANDBOX,
  [AXIA_POTTSTOWN_FIXTURE_LINE]: GroupIds.AXIA_LIVE_SANDBOX,
  [UPPERLINE_GA_LINE]: GroupIds.UPPERLINE_GEORGIA_LIVE,
  [ENTP_LINE]: GroupIds.ENT_PARTNERS_LIVE,
  [ENTP_SCI_LINE]: GroupIds.ENT_PARTNERS_SCI_LIVE,
  [NIMBUS_SCW_LINE]: GroupIds.NIMBUS_LIVE,
  [NIMBUS_ROCK_HILL_LINE]: GroupIds.NIMBUS_LIVE,
  [NIMBUS_MACON_LINE]: GroupIds.NIMBUS_LIVE,
  [TPR_BILTMORE_VOICE_LINE]: GroupIds.TPR_BILTMORE_LIVE,
  [CENT_MOCK_LINE]: GroupIds.ENT_PARTNERS_LIVE_SANDBOX,
  [ENTP_MOCK_LINE]: GroupIds.ENT_PARTNERS_LIVE_SANDBOX,
  [ENTP_SCI_MOCK_LINE]: GroupIds.ENT_PARTNERS_SCI_LIVE_SANDBOX,
  [NIMBUS_SCW_MOCK_LINE]: GroupIds.NIMBUS_LIVE_SANDBOX,
  [NIMBUS_ROCK_HILL_MOCK_LINE]: GroupIds.NIMBUS_LIVE_SANDBOX,
  [NIMBUS_MACON_MOCK_LINE]: GroupIds.NIMBUS_LIVE_SANDBOX,
  [TPR_BILTMORE_VOICE_MOCK_LINE]: GroupIds.TPR_BILTMORE_LIVE_SANDBOX,
  [TPR_BILTMORE_TELNYX_TEST_LINE]: GroupIds.TPR_BILTMORE_LIVE_SANDBOX,
  [UPPERLINE_GA_MOCK_LINE]: GroupIds.UPPERLINE_GEORGIA_LIVE_SANDBOX,
  [PMG_SANDBOX_TWILIO_NUMBER]: GroupIds.PMG_LIVE_SANDBOX,
};

// A mock test line borrows its live counterpart's inbound-line config (enabled intents), so the mock
// inherits prod and we don't duplicate — or risk diverging — line config in workflows.json. This alias
// does not rewrite transfer destinations: CENT_MOCK_LINE deliberately uses the real CENT destination
// DIDs for full-audio IVR QA while its sandbox group continues to prevent real EHR side effects. The
// mock groups already resolve to the live config dir (GROUP_CONFIG_DIR_BY_GROUP_ID), so the only
// remaining per-line thing here is the enabled-intents lookup; generateWorkflowPrompts resolves it.
export const MOCK_LINE_TO_LIVE_LINE: Record<string, string> = {
  [CENT_MOCK_LINE]: ENTP_LINE,
  [ENTP_MOCK_LINE]: ENTP_LINE,
  [ENTP_SCI_MOCK_LINE]: ENTP_SCI_LINE,
  [NIMBUS_SCW_MOCK_LINE]: NIMBUS_SCW_LINE,
  [NIMBUS_ROCK_HILL_MOCK_LINE]: NIMBUS_ROCK_HILL_LINE,
  [NIMBUS_MACON_MOCK_LINE]: NIMBUS_MACON_LINE,
  [UPPERLINE_GA_MOCK_LINE]: UPPERLINE_GA_LINE,
};

export const GROUP_DISPLAY_NAMES: Record<string, string> = {
  [GroupIds.CONVENIENT_MD_LIVE]: GroupNames.CONVENIENT_MD,
  [GroupIds.CONVENIENT_MD_LIVE_SANDBOX]: GroupNames.CONVENIENT_MD,
  [GroupIds.VALERIE_HEALTH_DEV]: GroupNames.VALERIE,
  [GroupIds.VALERIE_HEALTH_GENERIC_DEMO]: GroupNames.VALERIE,
  [GroupIds.VALERIE_HEALTH_LIVE_SANDBOX]: GroupNames.VALERIE,
  [GroupIds.NIRA_LIVE]: GroupNames.NIRA,
  [GroupIds.NIRA_LIVE_SANDBOX]: GroupNames.NIRA,
  [GroupIds.NIMBUS_LIVE]: GroupNames.NIMBUS,
  [GroupIds.NIMBUS_LIVE_SANDBOX]: GroupNames.NIMBUS,
  [GroupIds.UPPERLINE_GEORGIA_LIVE]: GroupNames.UPPERLINE_GA,
  [GroupIds.UPPERLINE_GEORGIA_LIVE_SANDBOX]: GroupNames.UPPERLINE_GA,
  [GroupIds.ENT_PARTNERS_LIVE_SANDBOX]: GroupNames.ENT_PARTNERS,
  [GroupIds.ENT_PARTNERS_LIVE]: GroupNames.ENT_PARTNERS,
  [GroupIds.ENT_PARTNERS_SCI_LIVE_SANDBOX]: GroupNames.ENT_PARTNERS_SCI,
  [GroupIds.ENT_PARTNERS_SCI_LIVE]: GroupNames.ENT_PARTNERS_SCI,
  [GroupIds.SPORTORTHO_LIVE]: GroupNames.SPORT_ORTHO,
  [GroupIds.SPORTORTHO_LIVE_SANDBOX]: GroupNames.SPORT_ORTHO,
  [GroupIds.PMG_LIVE_SANDBOX]: "Pain Management Group",
};

export const SCI_VOICE_AGENT_COPY = Object.freeze({
  openingDescription: "I can help with scheduling or take a message so our team can call you back",
  callerRequestedTransferOffer:
    "Our clinic is currently experiencing a high volume of calls. Would you like to leave a message with me for a callback?",
  telephoneEncounterFollowUpMessage: "Staff will reply within 24 hours.",
});

// One-line functional description injected into the legacy agent's opening greeting, right after
// the clinic introduction. Mirrors the slow-thinker `presentation.openingDescription` so both
// runtimes greet callers identically. Optional per group — groups without an entry keep the plain
// greeting.
export const GROUP_OPENING_DESCRIPTIONS: Partial<Record<string, string>> = {
  [GroupIds.ENT_PARTNERS_SCI_LIVE]: SCI_VOICE_AGENT_COPY.openingDescription,
  [GroupIds.ENT_PARTNERS_SCI_LIVE_SANDBOX]: SCI_VOICE_AGENT_COPY.openingDescription,
  [GroupIds.UPPERLINE_GEORGIA_LIVE]: "I can help with scheduling and general questions",
  [GroupIds.UPPERLINE_GEORGIA_LIVE_SANDBOX]: "I can help with scheduling and general questions",
};

export const GROUP_CALLER_REQUEST_TRANSFER_OFFERS: Partial<Record<string, string>> = {
  [GroupIds.ENT_PARTNERS_SCI_LIVE]: SCI_VOICE_AGENT_COPY.callerRequestedTransferOffer,
  [GroupIds.ENT_PARTNERS_SCI_LIVE_SANDBOX]: SCI_VOICE_AGENT_COPY.callerRequestedTransferOffer,
};

export const GROUP_TELEPHONE_ENCOUNTER_FOLLOW_UP_MESSAGES: Partial<Record<string, string>> = {
  [GroupIds.ENT_PARTNERS_SCI_LIVE]: SCI_VOICE_AGENT_COPY.telephoneEncounterFollowUpMessage,
  [GroupIds.ENT_PARTNERS_SCI_LIVE_SANDBOX]: SCI_VOICE_AGENT_COPY.telephoneEncounterFollowUpMessage,
};

export const INBOUND_NUMBER_TO_LOCATION_EHR_ID: Record<string, string> = {
  [CTNC_NEW_PATIENT_LINE]: "1",
  [CTNC_EXISTING_PATIENT_LINE]: "1",
  [STAGING_NUMBER]: "150",
  // [UPPERLINE_GA_LINE]: "<upperline-ga-department-ehr-id>",
  // [ENTP_LINE]: "<entp-sandbox-location-ehr-id>",
};

export function getLocationEhrIdForNumber(calledNumber: string | null | undefined): string | null {
  if (!calledNumber) return null;

  return INBOUND_NUMBER_TO_LOCATION_EHR_ID[calledNumber] ?? null;
}
